import React from 'react'
import './../App.css'
import './/../style/ourteam.css'
import Pagetitle from './../components/pagetitle/Pagetitle';
import pardeepmeghwar from './../Images/Pardeep-Meghwar-197756b410bbc31b75f2e6a14eaf239f.png'
import ismailmemon from './../Images/ismail-c622959cfe73a458ed1e69a9ee056f7c.png'
import ahmedali from './../Images/Ahmed-Ali-1-d1adecca60d56c9febe0e44d69981d79.png'
import danishraaz from './../Images/Danish-Raaz-bb452b4d941393ad25edda9cff6c76cf.png'
import nandlal from './../Images/nand-lal-1fe027b0ebb2dd2b4e7f9f27eb90fb8f.png'
import amarsuthar from './../Images/Amar-94a739baaa5c82bb987e04168dc2e5b9.png'
import hishmatrai from './../Images/Hishmat-Rai-084918adaca95b0030794da284de373a.png'
import berbal from './../Images/beerbal-4efbc832a23c209ea93ecd9bf0a7aff8.png'
import sunnelsuthar from './../Images/Suneel-8895ab6e0f7d952a820d4afdecf99343.png'
import khatumal from './../Images/Khatumal-2fb5b4707f20766c9065a5fb8909d61b.jpg'
import Khanjipir from './../Images/KhanjiPir-56e1535b47fd360a1bd3764f5dfd2b80.jpg'
import { TiSocialLinkedin } from 'react-icons/ti'
export default function Ourteam() {
  return (
    <div>
      <Pagetitle parentpage="Home" pagename="Our Team"/>
      <div className="ourteam_section-1 pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6" >
              <div className="user_box">
                <div className="image">
                  <img src={pardeepmeghwar} />
                </div>
                <div className="user_data">
                  <h3>Pardeep Meghwar</h3>
                  <p>Founder & Chairman</p>
                  <a href='https://pk.linkedin.com/in/pardeepmeghwar'><TiSocialLinkedin /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="user_box">
                <div className="image">
                  <img src={ismailmemon} />
                </div>
                <div className="user_data">
                  <h3>Ismail Memon</h3>
                  <p>CEO</p>
                  <a href='https://www.linkedin.com/in/ismail-memon-1874a2204/'><TiSocialLinkedin /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="user_box">
                <div className="image">
                  <img src={ahmedali} />
                </div>
                <div className="user_data">
                  <h3>Ahmed Ali</h3>
                  <p>Director</p>
                  <a href='https://www.linkedin.com/in/ahmed-ali263'><TiSocialLinkedin /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="user_box">
                <div className="image">
                  <img src={danishraaz} />
                </div>
                <div className="user_data">
                  <h3>Danish Raaz</h3>
                  <p>Lead Trainer</p>
                  <a href='https://pk.linkedin.com/in/danishraaz'><TiSocialLinkedin /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="user_box">
                <div className="image">
                  <img src={nandlal} />
                </div>
                <div className="user_data">
                  <h3>Nand Lal</h3>
                  <p>Manager</p>
                  <a href='https://www.linkedin.com/in/nand-lal-581100156'><TiSocialLinkedin /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="user_box">
                <div className="image">
                  <img src={amarsuthar} />
                </div>
                <div className="user_data">
                  <h3>Amar Suthar</h3>
                  <p>Frontend Developer</p>
                  <a href='https://www.linkedin.com/in/amar-shivani-021a0a17b/'><TiSocialLinkedin /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="user_box">
                <div className="image">
                  <img src={hishmatrai} />
                </div>
                <div className="user_data">
                  <h3>Hishmat Rai</h3>
                  <p>Web Developer</p>
                  <a href='https://www.linkedin.com/in/hishmat-rai-787737170/'><TiSocialLinkedin /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="user_box">
                <div className="image">
                  <img src={berbal} />
                </div>
                <div className="user_data">
                  <h3>Beerbal</h3>
                  <p>Web Developer</p>
                  <a href='https://www.linkedin.com/in/beerbal-kumar-7893a418b/'><TiSocialLinkedin /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="user_box">
                <div className="image">
                  <img src={sunnelsuthar} />
                </div>
                <div className="user_data">
                  <h3>Suneel Kumar</h3>
                  <p>Mobile App Developer</p>
                  <a href='https://www.linkedin.com/in/suneel-kumar-b4b0a117b/'><TiSocialLinkedin /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="user_box">
                <div className="image">
                  <img src={khatumal} />
                </div>
                <div className="user_data">
                  <h3>Khatu Mal</h3>
                  <p>Mobile App Developer</p>
                  <a href='https://www.linkedin.com/in/khatu-mal-75bb8318b/'><TiSocialLinkedin /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="user_box">
                <div className="image">
                  <img src={Khanjipir} />
                </div>
                <div className="user_data">
                  <h3>Khanji Pir</h3>
                  <p>Graphic Designer</p>
                  <a href='https://www.linkedin.com/in/khanji-pir714131216/'><TiSocialLinkedin /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
